export default __webpack_public_path__ + "static/media/RaWB0Ts-n00ne.63f0d137.gif";